import { useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
const API = `${BACKEND_URL}/api`;
const CACHE_KEY = 'bvesuvio_settings_v2';

export const defaultSettings = {
  logo_url: "https://customer-assets.emergentagent.com/job_agricola-vesuvio/artifacts/t5hpm5kl_491401522_10019356248083613_7662230933090295847_n%20%281%29.jpg",
  hero_image_url: "https://images.unsplash.com/photo-1752140225339-e16b632e6925?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
  hero_badge: "Azienda Agricola \u2022 Ercolano",
  hero_title: "I sapori autentici del Vesuvio",
  hero_subtitle: "Prodotti agricoli genuini direttamente dalla nostra terra. Coltiviamo con passione ai piedi del vulcano pi\u00f9 famoso del mondo.",
  value1_title: "Genuinit\u00e0",
  value1_text: "Prodotti coltivati con metodi tradizionali, senza additivi chimici.",
  value2_title: "Qualit\u00e0",
  value2_text: "Selezioniamo solo i migliori frutti della nostra terra vulcanica.",
  value3_title: "Passione",
  value3_text: "Tre generazioni di amore per la terra e i suoi frutti.",
  about_label: "La Nostra Storia",
  about_title: "Tre generazioni di passione",
  about_text: "Da oltre 50 anni coltiviamo con amore la terra vulcanica alle pendici del Vesuvio. La nostra famiglia ha tramandato di generazione in generazione i segreti della coltivazione, preservando tradizioni antiche e rispettando i ritmi della natura.",
  about_image_url: "https://images.pexels.com/photos/7658766/pexels-photo-7658766.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  cta_title: "Vuoi assaggiare i nostri prodotti?",
  cta_text: "Contattaci su WhatsApp per ordinare o per visitare la nostra azienda. Siamo sempre aperti per te!",
  chi_siamo_hero_image_url: "https://images.pexels.com/photos/2252584/pexels-photo-2252584.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  chi_siamo_story_image_url: "https://images.pexels.com/photos/7658766/pexels-photo-7658766.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  chi_siamo_story_title: "Tre generazioni di amore per la terra",
  chi_siamo_story_p1: "L'Azienda Agricola Le Bont\u00e0 del Vesuvio nasce dalla passione di una famiglia che da oltre cinquant'anni coltiva con dedizione le terre fertili alle pendici del vulcano pi\u00f9 famoso del mondo.",
  chi_siamo_story_p2: "Tutto ebbe inizio negli anni '70, quando il nostro nonno decise di dedicare la sua vita alla coltivazione dei prodotti tipici del territorio vesuviano. Da allora, ogni generazione ha portato avanti questa tradizione, arricchendola con nuove conoscenze ma sempre nel rispetto dei metodi antichi.",
  chi_siamo_story_p3: "Oggi, la nostra azienda \u00e8 un punto di riferimento per chi cerca prodotti genuini e di qualit\u00e0. I nostri pomodorini del Piennolo DOP, l'olio extravergine d'oliva e le conserve artigianali raccontano la storia di una terra generosa e di una famiglia che la ama profondamente.",
  chi_siamo_territory_title: "La magia della terra vulcanica",
  chi_siamo_territory_p1: "Il Vesuvio non \u00e8 solo un simbolo iconico dell'Italia, ma anche una benedizione per la nostra agricoltura. La terra vulcanica, ricca di minerali e nutrienti, dona ai nostri prodotti caratteristiche uniche che non si trovano in nessun altro luogo al mondo.",
  chi_siamo_territory_p2: "Il clima mediterraneo, con inverni miti e estati calde, insieme alla composizione speciale del terreno, crea le condizioni perfette per la coltivazione dei nostri pomodorini del Piennolo, degli agrumi profumati e delle olive da cui ricaviamo il nostro pregiato olio extravergine.",
  chi_siamo_territory_p3: "Ogni prodotto che esce dalla nostra azienda porta con s\u00e9 l'essenza di questo territorio straordinario, un legame indissolubile tra la terra e il suo frutto.",
  chi_siamo_territory_image_url: "https://images.unsplash.com/photo-1752140225339-e16b632e6925?crop=entropy&cs=srgb&fm=jpg&q=85",
  timeline_0_year: "1970",
  timeline_0_title: "Le Origini",
  timeline_0_desc: "La famiglia inizia a coltivare i primi appezzamenti di terra alle pendici del Vesuvio.",
  timeline_1_year: "1990",
  timeline_1_title: "La Crescita",
  timeline_1_desc: "La seconda generazione amplia l'azienda e introduce nuove colture tradizionali.",
  timeline_2_year: "2010",
  timeline_2_title: "L'Innovazione",
  timeline_2_desc: "Otteniamo la certificazione DOP per i nostri pomodorini del Piennolo.",
  timeline_3_year: "Oggi",
  timeline_3_title: "Il Futuro",
  timeline_3_desc: "La terza generazione porta avanti la tradizione con passione e dedizione.",
  phone: "+39 338 252 3925",
  whatsapp_number: "393382523925",
  email_address: "lebontadelvesuvio1@gmail.com",
  address: "Via ex Cook 42, Ercolano (NA), 80056",
  orari: "Sempre aperto",
  facebook_url: "https://www.facebook.com/profile.php?id=100091821963346",
  maps_url: "https://maps.google.com/?q=Via+ex+Cook+42+Ercolano+NA+80056",
  contatti_hero_image_url: "https://images.unsplash.com/photo-1752140225339-e16b632e6925?crop=entropy&cs=srgb&fm=jpg&q=85",
  prodotti_info_label: "Qualità Garantita",
  prodotti_info_title: "Dalla nostra terra alla tua tavola",
  prodotti_info_p1: "Tutti i nostri prodotti vengono coltivati con metodi tradizionali, rispettando i cicli naturali della terra e senza l'uso di additivi chimici.",
  prodotti_info_p2: "La raccolta avviene al momento ottimale di maturazione, garantendo la massima freschezza e il sapore autentico che solo i prodotti del Vesuvio possono offrire.",
  prodotti_info_p3: "Contattaci per ordinare o per organizzare una visita alla nostra azienda, dove potrai vedere con i tuoi occhi come nascono i nostri prodotti.",
  prodotti_info_img1_url: "https://images.pexels.com/photos/9814625/pexels-photo-9814625.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  prodotti_info_img2_url: "https://images.pexels.com/photos/4033325/pexels-photo-4033325.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  prodotti_info_img3_url: "https://images.pexels.com/photos/14410454/pexels-photo-14410454.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  prodotti_info_img4_url: "https://images.pexels.com/photos/5946083/pexels-photo-5946083.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  intro_video_url: "",
  galleria_hero_image_url: "https://images.pexels.com/photos/1084540/pexels-photo-1084540.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  negozio_hero_image_url: "https://images.unsplash.com/photo-1752140225339-e16b632e6925?crop=entropy&cs=srgb&fm=jpg&q=85",
  news_hero_image_url: "https://images.pexels.com/photos/1327838/pexels-photo-1327838.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  recensioni_hero_image_url: "https://images.pexels.com/photos/3184183/pexels-photo-3184183.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

/** Legge dal localStorage le impostazioni salvate (o null se assenti). */
const getCache = () => {
  try {
    const raw = localStorage.getItem(CACHE_KEY);
    if (raw) return JSON.parse(raw);
  } catch {}
  return null;
};

/** Cancella il cache (da chiamare dopo un salvataggio nell'admin). */
export const clearSettingsCache = () => {
  try { localStorage.removeItem(CACHE_KEY); } catch {}
};

/** Aggiorna il cache (da chiamare dopo un salvataggio nell'admin). */
export const writeSettingsCache = (data) => {
  try { localStorage.setItem(CACHE_KEY, JSON.stringify(data)); } catch {}
};

export const useSiteSettings = () => {
  // Parte subito dal cache → nessun flash di immagini default
  const cached = getCache();
  const [settings, setSettings] = useState(
    cached ? { ...defaultSettings, ...cached } : defaultSettings
  );
  const [loading, setLoading] = useState(!cached);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await axios.get(`${API}/settings`);
        const data = { ...defaultSettings, ...res.data };
        setSettings(data);
        // Aggiorna il cache con i dati freschi
        writeSettingsCache(res.data);
      } catch {
        // Mantieni cache o defaults — non sovrascrivere con nulla
      } finally {
        setLoading(false);
      }
    };
    fetchSettings();
  }, []);

  return { settings, loading };
};
